export function maskEmail(email: string): string {
  if (!email) return ''

  const [username, provider] = email.split('@')

  const TOTAL_PERCENT = 100
  const REMAINING_EMAIL_PERCENT = 30

  const emailFirstCharsCount = Math.floor(
    (username.length * REMAINING_EMAIL_PERCENT) / TOTAL_PERCENT,
  )
  const emailRemovedCharsCount = username.length - emailFirstCharsCount

  const emailFirstChars = username.slice(0, emailFirstCharsCount)
  const asteriskFillChars = '*'.repeat(emailRemovedCharsCount)

  return `${emailFirstChars}${asteriskFillChars}@${provider}`
}
